import { getErrorMessage } from '../utils/errors';

import { getBrowserSessionId } from './analytics/getBrowserSessionId';
import { getTabId } from './analytics/getTabId';
import { postRequest } from './api';

const LOGGED_PROCESS_NAME_KEY = 'logged_process_name';
const LOGGED_PROCESS_ID_KEY = 'logged_process_id';

function generateId() {
  if (typeof window !== 'undefined' && typeof window.crypto?.randomUUID === 'function') {
    return window.crypto.randomUUID();
  }

  return `${Date.now()}-${(Math.random() * 100).toFixed(0)}`;
}

export function startLoggedProcess(name: string) {
  try {
    localStorage.setItem(LOGGED_PROCESS_NAME_KEY, name);
    localStorage.setItem(LOGGED_PROCESS_ID_KEY, generateId());
  } catch {}
}

export function endLoggedProcess() {
  try {
    localStorage.removeItem(LOGGED_PROCESS_NAME_KEY);
    localStorage.removeItem(LOGGED_PROCESS_ID_KEY);
  } catch {}
}

export const logToNewRelic = (
  title: string,
  message: string | Record<string, any>,
  method: 'fatal' | 'info' | 'debug' | 'error' | 'warn' = 'info',
  context?: Record<string, any>,
) => {
  try {
    const browserSessionId = getBrowserSessionId();
    const tabId = getTabId();

    const fullContext = { ...(context || {}) };

    try {
      const loggedProcessName = localStorage.getItem(LOGGED_PROCESS_NAME_KEY);
      const loggedProcessId = localStorage.getItem(LOGGED_PROCESS_ID_KEY);

      if (loggedProcessId && loggedProcessName) {
        fullContext.ongoingProcess = {
          name: loggedProcessName,
          traceId: loggedProcessId,
        };
      }
    } catch {}

    void postRequest('/v2/debug/log', {
      title: `Players-Client: ${title}`,
      message:
        typeof message === 'string'
          ? message + ` [Browser Session ID: ${browserSessionId}] [Tab ID: ${tabId}]`
          : {
              ...message,
              browserSessionId,
              tabId,
            },
      method,
      context: fullContext,
    });
  } catch (e) {
    const errorMessage = getErrorMessage(e);
    console.error(`Error sending log: ${errorMessage}`);
  }
};
